import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import {
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from 'reactstrap';

import { FaFileExcel } from 'react-icons/fa';
import { IconSize } from 'pages/TimeAttendance/TimeAttendanceExport/constants';

interface ExportButtonProps {
  onExportDaily: () => Promise<void>;
  onExportMonthly?: () => void;
  isExporting?: boolean;
}
const ExportButton = ({
  onExportDaily,
  onExportMonthly,
  isExporting = false,
}: ExportButtonProps) => {
  const [dropdownOpen, setDropdownOpen] = useState(false);

  const toggle = () => setDropdownOpen((prevState) => !prevState);
  const { t } = useTranslation();

  return (
    <Dropdown
      isOpen={dropdownOpen}
      toggle={toggle}
      className="material-shadow btn-group"
    >
      <DropdownToggle
        caret
        className="btn-soft-info material-shadow-none d-flex align-items-center"
        id="btn-export"
        disabled={isExporting}
      >
        <div className="d-flex align-items-center">
          <FaFileExcel size={IconSize} className="mx-1" />
        </div>
        <div className="d-flex">{isExporting ? 'Exporting...' : t('Export')}</div>
      </DropdownToggle>

      <DropdownMenu className="dropdownmenu-info">
        <DropdownItem
          className="text-steel-gray"
          onMouseOver={(e) =>
            e.currentTarget.classList.remove('text-steel-gray')
          }
          onMouseOut={(e) => e.currentTarget.classList.add('text-steel-gray')}
          onClick={async () => {
            setDropdownOpen(false);
            await onExportDaily();
          }}
          disabled={isExporting}
        >
          {t('Daily Report')}
        </DropdownItem>
        <DropdownItem
          className="text-steel-gray"
          onMouseOver={(e) =>
            e.currentTarget.classList.remove('text-steel-gray')
          }
          onMouseOut={(e) => e.currentTarget.classList.add('text-steel-gray')}
          onClick={() => {
            setDropdownOpen(false);
            onExportMonthly?.();
          }}
          disabled={isExporting || !onExportMonthly}
        >
          {t('Monthly Report')}
        </DropdownItem>
      </DropdownMenu>
    </Dropdown>
  );
};

export default ExportButton;
